/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { profilesInvoicePrimary } from '../../axios/profilesInvoicePrimary'
import type {
	ProfilesInvoicePrimaryError,
	ProfilesInvoicePrimaryPathParams,
	ProfilesInvoicePrimaryResponse,
} from '../../types/ProfilesInvoicePrimary'

export const profilesInvoicePrimaryMutationKey = () =>
	[{ url: '/:organisation/profiles/:profile/invoice/primary' }] as const

export type ProfilesInvoicePrimaryMutationKey = ReturnType<typeof profilesInvoicePrimaryMutationKey>

export type ProfilesInvoicePrimaryVariables = {
	organisation: ProfilesInvoicePrimaryPathParams['organisation']
	profile: ProfilesInvoicePrimaryPathParams['profile']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::invoicePrimary */
export function useProfilesInvoicePrimary<TContext = unknown>(
	options?: UseMutationOptions<
		ProfilesInvoicePrimaryResponse,
		AxiosError<ProfilesInvoicePrimaryError>,
		ProfilesInvoicePrimaryVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: profilesInvoicePrimaryMutationKey(),
		mutationFn: ({ organisation, profile }: ProfilesInvoicePrimaryVariables) =>
			profilesInvoicePrimary(organisation, profile, config).then(res => res.data),
		...options,
	})
}
